import React, {ReactNode} from 'react'
import {
	Outlet
} from 'react-router-dom';
type Props = { 
	currentNav: string,
 }

const MainLayout = ({currentNav}: Props) => {
    return (
        <main id="main" className="main">

			<div className="pagetitle">
			<h1>{currentNav}</h1>
			<nav>
				<ol className="breadcrumb">
				<li className="breadcrumb-item"><a href="/">Home</a></li>
				<li className="breadcrumb-item active">{currentNav}</li>
				</ol>
			</nav>
			</div>

			<section className="section dashboard">
				<div className="row">
      				<Outlet />
				</div>
			</section>

		</main>
    )
}

export default MainLayout